import React from 'react';
import '../../style/legacy/Services.css'; // External CSS for styling
import GenericResearchNav from '../Research/GenericResearchNav';
import NewFooter from '../../common/NewFooter';
import SEO from '../../common/SEO';

// Importing images
import services1 from '../../../assets/images/services/img6.jpg';
import services2 from '../../../assets/images/services/img5.jpg';
// import services3 from '../../../assets/images/services/services3.jpg';
// import Home from '';

const Services = () => {
  const services = [
    {
      image: services1,
      title: 'Manufacture And Supply of Products',
      description:
        'Specializing in manufacturing and supplying high-quality laboratory equipment and specialized machines, our comprehensive services cover the entire process from production to delivery, ensuring excellence and innovation for educational institutions scientific and research needs. With a focus on quality and customer satisfaction, we strive to exceed expectations in every aspect of our operations.',
    },
    {
      image: services2,
      title: 'Installation And Repairing of Products',
      description:
        'We understand the importance of reliable equipment in your work or study environment. Our team is dedicated to ensuring that your equipment is not only set up correctly but also promptly repaired if any issues arise. With our services, you can focus on your tasks with confidence, knowing that we are committed to keeping your equipment running smoothly for years to come.',
    },
    // Add more services as needed
  ];

  return (
    <>
      <SEO 
        title="MTech & PhD Thesis Writing Services Bhopal | Paper Writing & Plagiarism Check"
        description="Comprehensive MTech Thesis Writing, PhD Thesis writing service, Research paper writing and publication, SCI paper writing bhopal, review paper writing and plagiarism check."
        keywords={[
          "Mtech Thesis Writing",
          "PhD Thesis writing service and help",
          "best thesis writing services in bhopal",
          "Research paper writing and publication",
          "Paper Writing Bhopal",
          "Plagiarism Check Bhopal",
          "Review paper writing bhopal",
          "SCI paper writing bhopal",
          "Scopus paper writing bhopal"
        ]}
        canonicalPath="/services"
      />

      <GenericResearchNav />
      <div className='services-container pt-24 min-h-screen'>
        {/* Hero Section */}
        <section className='hero'>
          <h1>Our Services</h1>
          <p>
            AEG Consultancy Services Pvt. Ltd. is a premier provider of
            end-to-end research solutions for academic and industrial sectors.
            The company offers a wide range of services, including the
            development of experimental setups for researchers, support for
            research publications, and the design and construction of advanced
            research facilities.
          </p>
        </section>

        {/* Services Grid */}
        <section className='services-grid'>
          {services.map((service, index) => (
            <div key={index} className='service-card'>
              <div className='image-container'>
                <img
                  src={service.image}
                  alt={`${service.title} - AEG Research Services in Bhopal`}
                  className='service-image'
                />
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </section>
        {/* Back to AEG button with highlight effect */}
      </div>
      <NewFooter />
    </>
  );
};

export default Services;
